<ng-container *ngIf="componentTexts">
  <div class="po-number d-flex justify-content-end">
    <div class="po-number__input d-flex flex-grow-1 flex-nowrap align-items-center">
      <udex-text-field
        #poInput
        (input)="onPoInput($event)"
        (blur)="sendPoNumber(poNumber, false)"
        (mouseleave)="sendPoNumber(poNumber, false)"
        [label]="('checkoutReview.poNumber' | cxTranslate) + (' ') + ('common.optional' | cxTranslate)"
        class="flex-grow-1"
        maxlength="35"
      ></udex-text-field>
      <dcp-icon-button-tooltip
        class="udex-ms-4"
        data-cy="checkout-initial-cost"
        [openOnClick]="true"
        accessibleName="purchoseOrderTooltip">
        <span class="body--s text-grey">{{ componentTexts.poNumberTooltip }}</span>
      </dcp-icon-button-tooltip>
    </div>
  </div>
  <div class="po-input-separator udex-pb-16 udex-mb-20"></div>
</ng-container>
